import apiClient from "../apiClient";
import API_ENDPOINTS from "../endpoints";

const activityLogService = {
  getActivityLog: (params) =>
    apiClient.get(API_ENDPOINTS.GET_ACTIVITY_LOG, { params }),
  getModuleList: (params) =>
    apiClient.get(API_ENDPOINTS.GET_MODULE_LIST, { params }),
  getActivityList: (params) =>
    apiClient.get(API_ENDPOINTS.GET_ACTIVITY_LIST, { params }),
  addActivityLog: (body) =>
    apiClient.post(API_ENDPOINTS.ADD_ACTIVITY_LOG, body),
  //   editAnalyticsUrl: (body) =>
  //     apiClient.patch(API_ENDPOINTS.EDIT_ANALYTICS_URL, body),
};
export default activityLogService;
